import { render, staticRenderFns } from "./GripResult.vue?vue&type=template&id=f81d0758&scoped=true&"
import script from "./GripResult.vue?vue&type=script&lang=ts&"
export * from "./GripResult.vue?vue&type=script&lang=ts&"
import style0 from "./GripResult.vue?vue&type=style&index=0&id=f81d0758&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81d0758",
  null
  
)

export default component.exports